/**
 * The event handler for the open tooltip synthetic event.
 *
 * @template C Content data type
 * @param {SetTooltipSettingsDebounced<C>} setTooltipSettingsDebounced
 * @param {Dispatch<SetStateAction<TooltipSettings>>} setTooltipSettings
 * @returns {(event: CustomEventInit) => void} The open tooltip synthetic event payload
 */
export var openTooltipEventHandler = function (setTooltipSettingsDebounced, setTooltipSettings) {
    return function (_a) {
        var _b = _a.detail, x = _b.x, y = _b.y, contentData = _b.contentData, getContent = _b.getContent;
        setTooltipSettingsDebounced(x, y, contentData, getContent, setTooltipSettings);
    };
};
//# sourceMappingURL=openTooltipEventHandler.js.map